/**
 * Which template detail pages have real (non-placeholder) content shipped.
 *
 * Drives:
 * - Runtime `robots` meta (RouteHead): placeholder pages are `noindex,nofollow`.
 * - Prerender script inclusion (scripts/build-seo-html.mjs): only listed IDs
 *   get static HTML shells with per-template metadata.
 * - Sitemap membership (public/sitemap.xml): only listed IDs appear.
 *
 * When shipping real content for a template, add its ID here AND to
 * `scripts/build-seo-html.mjs` AND to `public/sitemap.xml`.
 */
export const TEMPLATE_IDS_WITH_REAL_CONTENT: ReadonlySet<string> = new Set([
  // Nine retro formats
  "start-stop-continue",
  "4ls",
  "sailboat",
  "mad-sad-glad",
  "daki",
  "starfish",
  "plus-delta",
  "www",
  "lean-coffee",
  // Three general-purpose board templates
  "groceries",
  "prevail",
  "gear-list",
  "household-chores",
]);

export function hasRealContent(templateId: string): boolean {
  return TEMPLATE_IDS_WITH_REAL_CONTENT.has(templateId);
}
